import { css, html, LitElement } from 'lit';
import './TemplateContainer.js';
import './MovingHandle.js';
import './FetchMixin.js';
import { FetchMixin } from './FetchMixin.js';
import { fetchDataForEditorStores } from './EditorDataThunks.js';
import { editorDataStore } from './EditorDataStore.js';
import './AppContainerLoadingOverlay.js';
import './AlertComponent.js';
import platformStore from './PlatformStore.js';
import { changeMode, changePlatformSize, changeXY, changeScale } from './PlatformSlice.js';
import { addToolBoxItem, updateToolBoxItem, deleteToolBoxItem, findByComponentName, findByCustomComponentName, htmlToJson, isValidDOMString, jsonToHtml, searchByTagName as searchByComponentName, syncUserScriptComponent, templateItemToHtml } from './ToolBoxItemSlice.js';
import { findElementById } from './TemplateJsonSlice.js';
import alertStore from './AlertStore.js';
import { setAlert } from './AlertSlice.js';
import { parseJSDoc, extractDeclarationInfo, findCustomElementDefinitions } from './ScriptParser.js';
import { addAttributeToExistingTag, addNewTag, selectAttributeByTagName, setIdTypeCommentForTag } from './AttributeItemSlice.js';
import { addEventToExistingTag, addNewTag as addNewEventTag, selectEventByTagName } from './EventItemSlice.js';
import './SnapshotManager.js';
import './dashboard/MessageBox.js';
import SnapshotController from '../snapshot/SnapshotController.js';
import { initializeCommandEngine, executeCommandList } from '../commands/CommandEngine.js';
import { resetRoot } from './TemplateSelectedRootSlice.js';
import { loadLocalAiConfig, LS_AI_CONFIG_KEY } from './UserSettingSlice.js';
import './AppTourGuide.js';
import './AppTutorialModal.js';
import './StarterTemplateModal.js';
import { templateHistoryManager } from './TemplateHistoryManager.js'; // 履歴マネージャーをインポート

// lit-virtualizerのエラー抑制のためのヘルパー関数をインポート
import { preventResizeObserverLoopErrorEventDefaults } from '@lit-labs/virtualizer/support/resize-observer-errors.js';

// アプリケーションの早い段階で一度だけ呼び出す
preventResizeObserverLoopErrorEventDefaults();

/**
 * アプリケーションコンテナ
 */
export class AppContainer extends FetchMixin(LitElement) {
    static styles = css`
        :host {
            user-select: none;
            overscroll-behavior: none; 
            display: block;
            width: 100vw;
            height: 100vh;
        }
            
        platform-background{
            z-index: -1000;
        }

        platform-switcher {
            position: fixed;
            top: 20px;
            transform: translateX(-50%);
            left: 50%; 
        }

        .menu-button {
            border-radius: 50%;
            border-width: 1px;
            border-color: #818181;
            border-style: solid;
        }

        .menu-button i {
          height: 35px;
          width: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          
          font-size: 20px;
          color: gray;
        }

        .app-menu-list {
          display: none;
          position: fixed;
          flex-direction: column;
          z-index: 100;
          width: 250px;
          right: 35px;
          top: 40px;
          background: rgba(0, 0, 0, 0.77);
          border-radius: 4px;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 6px;
          z-index: 100;
        }

        .app-menu-list-panel {
          max-height: 200px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
        }

        .app-menu-item {
          flex-grow: 1;
          color: white;

          padding: 12px 20px;
          color: rgb(255 255 255);
          font-size: 16px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          border-bottom: 1px solid #dfdfdf;
        }

        .app-menu-item:hover {
          background-color: rgba(255, 255, 255, 0.7);
          color: rgb(0, 0, 0);
        }
        
        platform-bottom-menu {
            position: fixed;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
        }

        right-container{
            display: block;
            position: absolute;
            right: 0px;
            width: 25%;
            min-width: auto; 
        }
        
        left-container {
            display: block;
            position: absolute;
            left: 0px;
            width: 25%;
            min-width: auto; 
        }

        platform-container {
            position: fixed;
            z-index: 0;
        }

        template-container{
            z-index:2;
        }

        tool-box {
            z-index: 1;
        }

        property-container {
            z-index: 3;
        }

        script-container{
            z-index: 4;
        }
        
        ai-coder-window{
            display: none;
            position: absolute;
            z-index: 2000;
            width: 100%;
            height: 100%;
        }

        .snapshot-button {
            background-color: rgb(0, 123, 255);
            border-radius: 30px;
            border: none;
            color: white;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 16px;
            transition-duration: 0.4s;
            padding: 6px 15px;
        }
        .snapshot-button.red {
            background-color: rgba(255, 94, 94, 1);
        }
        .snapshot-button.dark {
            background-color: rgba(88, 134, 176, 1);
        }
        .snapshot-button.gray {
            background-color: rgba(163, 163, 163, 1);
        }

        /* 画面端D&D用エッジトリガーのスタイル */
        .edge-trigger {
            position: fixed;
            top: 0;
            bottom: 0;
            width: 50px;
            z-index: 9999;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 123, 255, 0.1);
            color: #007bff;
            font-size: 32px;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.2s, background 0.2s;
        }
        .edge-trigger.active {
            opacity: 1;
        }
        .edge-trigger.hover {
            background: rgba(0, 123, 255, 0.5);
            color: white;
        }
        .edge-trigger.left {
            left: 0;
            border-right: 2px dashed #007bff;
        }
        .edge-trigger.right {
            right: 0;
            border-left: 2px dashed #007bff;
        }
        @keyframes pulse-edge {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
        }
        .edge-trigger.hover i {
            animation: pulse-edge 0.5s infinite ease-in-out;
        }
        
        /* PC(1024px以上)では完全に非表示にする ▼▼▼ */
        @media (min-width: 1024px) {
            .edge-trigger {
                display: none !important;
            }
        }
        
        .preset-tag-button {
            transition: all 0.2s ease;
        }
        .preset-tag-button:hover {
            background-color: #e0e0e0 !important;
        }
        .confirm-ok-button {
            background-color: #007bff; border: none; padding: 10px 16px; border-radius: 6px; font-weight: 600; color: white; cursor: pointer; transition: background-color 0.2s;
        }
        .confirm-ok-button:hover { background-color: #0056b3; }
        .confirm-cancel-button {
            background-color: #f3f4f6; color: #374151; border: none; padding: 10px 16px; border-radius: 6px; font-weight: 600; cursor: pointer; transition: background-color 0.2s;
        }
        .confirm-cancel-button:hover { background-color: #e5e7eb; }
    `;

    //Litのプロパティ設定
    static properties = {
        loading: { type: Boolean },
        isGlobalDragging: { type: Boolean },
        dragHoverEdge: { type: String }
    }

    updated(changedProperties) {
        if (changedProperties.has('loading')) {
            const loadingOverlay = this.shadowRoot.querySelector('app-container-loading-overlay');
            if (loadingOverlay) {
                if (this.loading) {
                    loadingOverlay.style.display = 'flex';
                } else {
                    loadingOverlay.style.display = 'none';
                }
            }
        }
    }

    /**
     * コンストラクタ
     */
    constructor() {
        super();

        this.enableCloseWarning();

        // 左右のハンドル個別でダブルタップを検知するための変数を初期化
        this.lastLeftTapTime = 0;
        this.lastRightTapTime = 0;

        platformStore.subscribe(this.callbackPlatformStore.bind(this));

        // 最後に保存、または初期ロードされた際の状態のシグネチャを保持する変数
        this._savedStateSignature = null;

        // イベント「editor-json-save」の処理 (ここでUnahndled Rejectionを防ぐ)
        this.addEventListener('editor-json-save', async (event) => {
            try {
                await this.handleEditorJsonSaveEvent(event);
            } catch (err) {
                console.warn('[AppContainer] Save event failed:', err);
            }
        });

        // イベント「editor-json-save-and-close」の処理
        this.addEventListener('editor-json-save-and-close', this.handleEditorJsonSaveAndCloseEvent.bind(this));

        // イベント「editor-json-close」の処理
        this.addEventListener('editor-json-close', this.handleEditorJsonCloseEvent.bind(this));

        // イベント「editor-json-close」の処理
        this.addEventListener('show-tool-box-item-editor', this.handleShowToolBoxItemEditorEvent.bind(this));

        // イベント「tool-box-item-add」の処理
        this.addEventListener('tool-box-item-add', this.handleToolBoxItemAdd.bind(this));

        // イベント「tool-box-item-edit」の処理
        this.addEventListener('tool-box-item-edit', this.handleToolBoxItemEdit.bind(this));

        // イベント「tool-box-item-delete」の処理
        this.addEventListener('tool-box-item-delete', this.handleToolBoxItemDelete.bind(this));

        // イベント「begin-tool-box-item-edit」の処理
        this.addEventListener('begin-tool-box-item-edit', this.handleBeginToolBoxItemEdit.bind(this));

        // イベント「begin-tool-box-item-from-template」の処理
        this.addEventListener('begin-tool-box-item-from-template', this.handleBeginToolBoxItemFromTemplate.bind(this));

        // イベント「open-ai-coder-window」の処理
        this.addEventListener('open-ai-coder-window', this.handleOpenAICoderWindow.bind(this));

        // スナップショットマネージャー表示イベントのリスナー
        this.addEventListener('show-snapshot-manager', this.handleShowSnapshotManager.bind(this));

        // ファイルエクスプローラー表示イベントのリスナー
        this.addEventListener('show-file-explorer', this.handleShowFileExplorerEvent.bind(this));

        this.leftMovingHandleMoveing = false;
        this.leftMovingHandleX = 0;
        this.leftMovingHandleY = 0;

        this.rightMovingHandleMoving = false;
        this.rightMovingHandleX = 0;
        this.rightMovingHandleY = 0;

        this.touchTimer;

        this.touchStartX = 0;
        this.touchStartY = 0;
        this.MOVE_THRESHOLD = 10;

        // ダブルタップを検知するための変数と定数
        this.lastTapTime = 0;
        this.doubleTapThreshold = 300; // ダブルタップと見なす最大の間隔（ミリ秒）

        // グローバルD&Dエッジ用
        this._boundHandleAppDragStart = this.handleAppDragStart.bind(this);
        this._boundHandleAppDragEnd = this.handleAppDragEnd.bind(this);
        this._boundHandleGlobalDragMove = this.handleGlobalDragMove.bind(this);

        // バインド済みのリサイズハンドラを保持
        this._boundHandleLeftMouseMove = this.handleLeftMovingHandleMouseMove.bind(this);
        this._boundHandleLeftMouseUp = this.handleLeftMovingHandleMouseUp.bind(this);
        this._boundHandleRightMouseMove = this.handleRightMovingHandleMouseMove.bind(this);
        this._boundHandleRightMouseUp = this.handleRightMovingHandleMouseUp.bind(this);

        // ダブルクリック（dblclick）イベント用のバインドを追記
        this._boundToggleLeftPanel = this.toggleLeftPanel.bind(this);
        this._boundToggleRightPanel = this.toggleRightPanel.bind(this);
    }

    async connectedCallback() {
        super.connectedCallback();

        // エディタ画面全体で「引っ張って更新」や「バウンス」を禁止する ★★★
        document.body.style.overscrollBehavior = 'none';
        document.documentElement.style.overscrollBehavior = 'none';

        // 1. iOS Safari 等のジェスチャー（ズーム）を最上位で禁止
        this._blockNativeZoom = (e) => {
            if (e.scale !== 1) { // ズーム操作（ピンチ）の場合
                e.preventDefault();
            }
        };
        window.addEventListener('gesturestart', this._blockNativeZoom, { passive: false });
        window.addEventListener('gesturechange', this._blockNativeZoom, { passive: false });

        // 2. 2本指以上のタッチが始まった瞬間にブラウザのデフォルトズームを阻止
        window.addEventListener('touchstart', (e) => {
            if (e.touches.length >= 2) {
                e.preventDefault(); // これでブラウザのズームが発動しなくなる
            }
        }, { passive: false });

        // 3. Ctrl + ホイール（トラックパッドでのピンチ）を阻止
        window.addEventListener('wheel', (e) => {
            if (e.ctrlKey) {
                e.preventDefault();
            }
        }, { passive: false });

        // チュートリアル表示とツアー再起動のイベントリスナー
        this.boundHandleOpenTutorial = this.handleOpenTutorial.bind(this);
        this.boundHandleRestartTour = this.triggerTourGuide.bind(this);
        window.addEventListener('open-tutorial', this.boundHandleOpenTutorial);
        window.addEventListener('restart-tour', this.boundHandleRestartTour);

        // スターターテンプレートとAIエージェント起動の中継
        this.boundHandleApplyStarterTemplate = (e) => {
            const templateContainer = this.shadowRoot.querySelector('template-container');
            if (templateContainer && typeof templateContainer.applyStarterTemplate === 'function') {
                templateContainer.applyStarterTemplate(e.detail.type);
            }
        };
        window.addEventListener('apply-starter-template', this.boundHandleApplyStarterTemplate);

        this.boundHandleOpenAIAgentWindow = () => {
            const agentWindow = this.shadowRoot.querySelector('agent-chat-window');
            if (agentWindow) {
                agentWindow.show();
            }
        };
        window.addEventListener('open-ai-agent-window', this.boundHandleOpenAIAgentWindow);

        // グローバルD&Dリスナー登録
        window.addEventListener('app-drag-start', this._boundHandleAppDragStart);
        window.addEventListener('app-drag-end', this._boundHandleAppDragEnd);
        window.addEventListener('touchmove', this._boundHandleGlobalDragMove, { passive: false });
        window.addEventListener('mousemove', this._boundHandleGlobalDragMove, { passive: false });

        // 30日以上前の古いスナップショットをバックグラウンドで削除
        SnapshotController.cleanupOldSnapshots(30).catch(err => {
            console.error("古いスナップショットのクリーンアップ処理中にエラーが発生しました:", err);
        });

        try {
            let promises = [];
            //モジュールの動的インポート
            promises.push(import('./AgentEntry.js'));
            promises.push(import('./SnapshotManager.js'));
            promises.push(import('./AiCoderWindow.js'));
            promises.push(import('./FileExplorer.js'));
            promises.push(import('./LoginContainer.js'));
            promises.push(import('./AppMenuContainer.js'));
            promises.push(import('./AppListContainer.js'));
            promises.push(import('./AppHeaderContainer.js'));
            promises.push(import('./ToolBox.js'));
            promises.push(import('./ToolBoxItemEditor.js'));
            promises.push(import('./PlatformBackground.js'));
            promises.push(import('./PlatformContainer.js'));
            promises.push(import('./PlatformBottomManu.js'));

            promises.push(import('./AppContainerLoadingOverlay.js'));

            promises.push(import('./AppSettingStore.js').then(store => {
                this.appSettingStore = store.default;
                import('./AppSettingSlice.js').then(slice => {
                    this.appSettingSlice = slice;
                });
            }));

            promises.push(import('./EditorJsonVersionStore.js').then(store => {
                this.editorJsonVersionStore = store.default;
                import('./EditorJsonVersionSlice.js').then(slice => {
                    this.editorJsonVersionSlice = slice;
                });
            }));

            promises.push(import('./UserSettingStore.js').then(store => {
                this.userSettingStore = store.default;
                import('./UserSettingSlice.js').then(slice => {
                    this.userSettingSlice = slice;
                });
            }));

            promises.push(import('./TemplateSelectedModifierItemStore.js').then(store => {
                this.templateSelectedModifierItemStore = store.default;
                import('./TemplateSelectedModifierItemSlice.js').then(slice => {
                    this.templateSelectedModifierItemSlice = slice;
                    this.templateSelectedModifierItemStore.dispatch(this.templateSelectedModifierItemSlice.loadTemplateSelectedModifierItemData());
                });
            }));

            promises.push(import('./TemplateJsonStore.js').then(store => {
                this.templateJsonStore = store.default;
                import('./TemplateJsonSlice.js').then(slice => {
                    this.templateJsonSlice = slice;
                });
            }));

            promises.push(import('./TemplateSelectedRootStore.js').then(store => {
                this.templateSelectedRootStore = store.default;
                import('./TemplateSelectedRootSlice.js').then(slice => {
                    this.templateSelectedRootSlice = slice;
                });
            }));

            promises.push(import('./TemplateSelectedItemStore.js').then(store => {
                this.templateSelectedItemStore = store.default;
                import('./TemplateSelectedItemSlice.js').then(slice => {
                    this.templateSelectedItemSlice = slice;
                });
            }));

            promises.push(import('./AttributeItemStore.js').then(store => {
                this.attributeItemStore = store.default;
                import('./AttributeItemSlice.js').then(slice => {
                    this.attributeItemSlice = slice;
                    this.attributeItemStore.dispatch(this.attributeItemSlice.loadAttributeItemData());
                });
            }));

            promises.push(import('./EventItemStore.js').then(store => {
                this.eventItemStore = store.default;
                import('./EventItemSlice.js').then(slice => {
                    this.eventItemSlice = slice;
                    this.eventItemStore.dispatch(this.eventItemSlice.loadEventItemData());
                });
            }));

            promises.push(import('./ToolBoxItemStore.js').then(store => {
                this.toolBoxItemStore = store.default;
                import('./ToolBoxItemSlice.js').then(slice => {
                    this.toolBoxItemSlice = slice;
                    this.toolBoxItemStore.dispatch(this.toolBoxItemSlice.loadToolBoxData());
                });
            }));

            promises.push(import('./ScriptItemStore.js').then(store => {
                this.scriptItemStore = store.default;
                import('./ScriptItemSlice.js').then(slice => {
                    this.scriptItemSlice = slice;
                    this.scriptItemStore.dispatch(this.scriptItemSlice.loadScriptData());
                });
            }));

            promises.push(import('./PlatformDeviceStore.js').then(store => {
                this.platformDeviceStore = store.default;
                import('./PlatformDeviceSlice.js').then(slice => {
                    this.platformDeviceSlice = slice;
                    this.platformDeviceStore.dispatch(this.platformDeviceSlice.loadPlatformDevice());
                });
            }));

            promises.push(import('./ServiceWorkerItemStore.js').then(store => {
                this.serviceWorkerItemStore = store.default;
                import('./ServiceWorkerItemSlice.js').then(slice => {
                    this.serviceWorkerItemSlice = slice;
                    this.serviceWorkerItemStore.dispatch(this.serviceWorkerItemSlice.loadServiceWorkerItemData());
                });
            }));

            promises.push(import('./TestItemStore.js').then(store => {
                this.testItemStore = store.default;
                import('./TestItemSlice.js').then(slice => {
                    this.testItemSlice = slice;
                });
            }));

            promises.push(this.importPlatformSwitcher());
            promises.push(this.importPropertyContainer());
            promises.push(this.importScriptContainer());

            try {
                await Promise.all(promises);
            } catch (importError) {
                console.error("【重大なエラー】モジュールの動的インポートに失敗しました:", importError);
                this.loading = false; // エラー時もローディングを消す
                return; // 処理をここで止める
            }

            // 全てのストアが利用可能になった後で、コマンドエンジンを初期化
            initializeCommandEngine({
                templateJsonStore: this.templateJsonStore,
                scriptItemStore: this.scriptItemStore,
                eventItemStore: this.eventItemStore,
                appSettingStore: this.appSettingStore,
                attributeItemStore: this.attributeItemStore,
                toolBoxItemStore: this.toolBoxItemStore,
                serviceworkerItemStore: this.serviceWorkerItemStore,
            });

            const data = await editorDataStore.dispatch(fetchDataForEditorStores().bind(this));
            const appSettings = data.payload.appSettings;
            if (appSettings && appSettings.length !== 0) {
                this.appSettingStore.dispatch(this.appSettingSlice.loadAppSettingData(appSettings));
            }

            const attributeItems = data.payload.attributeItems;
            if (attributeItems && attributeItems.length !== 0) {
                this.attributeItemStore.dispatch(this.attributeItemSlice.loadAttributeItemData(attributeItems));
            }

            const editorJsonVersion = data.payload.editorJsonVersion;
            if (editorJsonVersion) {
                this.editorJsonVersionStore.dispatch(this.editorJsonVersionSlice.loadCurrentVersion(editorJsonVersion));
            }

            const aiCodingEnabled = data.payload.aiCodingEnabled;
            if (aiCodingEnabled) {
                this.userSettingStore.dispatch(this.userSettingSlice.setAiCodingEnabled(aiCodingEnabled));
            }

            const isUserGeminiApiKeyRegistered = data.payload.isUserGeminiApiKeyRegistered;
            if (isUserGeminiApiKeyRegistered) {
                this.userSettingStore.dispatch(this.userSettingSlice.setUserGeminiApiKeyRegistered(isUserGeminiApiKeyRegistered));
            }

            // AI設定のローカル読み込み
            try {
                const savedConfig = localStorage.getItem(LS_AI_CONFIG_KEY);
                if (savedConfig) {
                    const parsedConfig = JSON.parse(savedConfig);
                    this.userSettingStore.dispatch(this.userSettingSlice.loadLocalAiConfig(parsedConfig));
                }
            } catch (e) {
                console.warn('Failed to load AI settings from LocalStorage', e);
            }

            const eventItems = data.payload.eventItems;
            if (eventItems && eventItems.length !== 0) {
                this.eventItemStore.dispatch(this.eventItemSlice.loadEventItemData(eventItems));
            }

            const scriptItems = data.payload.scriptItems;
            if (scriptItems && scriptItems.length !== 0) {
                this.scriptItemStore.dispatch(this.scriptItemSlice.loadScriptData(scriptItems));
            }

            const serviceWorkerItems = data.payload.serviceWorkerItems;
            if (serviceWorkerItems && serviceWorkerItems.length !== 0) {
                this.serviceWorkerItemStore.dispatch(this.serviceWorkerItemSlice.loadServiceWorkerItemData(serviceWorkerItems));
            }

            const templateItems = data.payload.templateItems;
            if (templateItems && templateItems.length !== 0) {
                this.templateJsonStore.dispatch(this.templateJsonSlice.loadTemplateJson(templateItems));
            }

            const toolBoxItems = data.payload.toolBoxItems;
            if (toolBoxItems && toolBoxItems.length !== 0) {
                this.toolBoxItemStore.dispatch(this.toolBoxItemSlice.loadToolBoxCustomData(toolBoxItems));
            }

            const testItems = data.payload.testItems;
            if (testItems && Object.keys(testItems).length !== 0) {
                this.testItemStore.dispatch(this.testItemSlice.loadTestData(testItems));
            }

            this.syncAllUserScriptsToToolbox();

            // 選択済みのテンプレートをリセット
            this.templateSelectedRootStore.dispatch(this.templateSelectedRootSlice.resetRoot());
            this.templateSelectedItemStore.dispatch(this.templateSelectedItemSlice.deselectItem());

            const windowWidth = window.innerWidth;

            // 初回ロード完了時点のデータ状態を記録
            setTimeout(() => {
                this._updateSavedStateSignature();
            }, 1000);
            if (windowWidth < 1024) {
                let mobileWidth = windowWidth - 183;

                // 逆算値が大きくなりすぎるのを防ぐため、上限値を 320px に制限します。
                if (mobileWidth > 320) {
                    mobileWidth = 320;
                }

                let mobileHeight = mobileWidth * 20 / 9;
                mobileWidth = Math.floor(mobileWidth);
                mobileHeight = Math.floor(mobileHeight);

                platformStore.dispatch(changePlatformSize({ width: mobileWidth, height: mobileHeight }));
                platformStore.dispatch(changeScale(100));
            }

        } catch (e) {
            console.error("エディタの初期化中にエラーが発生しました:", e);
        } finally {
            // エラーが起きても確実にローディングを消す
            this.loading = false;
        }

        if (this.editorJsonVersionStore.getState().editorJsonVersion.currentVersion === 'init') {
            //　初回の保存処理を実行
            await this.handleEditorJsonSaveEvent();
        }

        // 1. まずスナップショットの確認ダイアログが終わるのを await で待つ
        await this.checkForOrphanedSnapshots();

        // 2. 空のアプリならスターターモーダルを表示
        const isAppEmpty = this.templateJsonStore.getState().templateJson.templates[0].children.length === 0;
        const isTourCompleted = localStorage.getItem('pwappy_tour_completed');

        if (isAppEmpty && !this.getAttribute('is-demo')) {
            const starterModal = this.shadowRoot.querySelector('starter-template-modal');
            if (starterModal) {
                // モーダルが閉じたときにツアー未完了ならツアーを開始する
                starterModal.addEventListener('starter-modal-closed', (e) => {
                    setTimeout(() => {
                        // AIに作ってもらうが選ばれた場合はツアーの自動開始をスキップする
                        if (e.detail?.selectedType === 'ai') {
                            return;
                        }
                        const checkTourCompleted = localStorage.getItem('pwappy_tour_completed');
                        if (!checkTourCompleted && !this.getAttribute('is-demo')) {
                            this.triggerTourGuide();
                        }
                    }, 500);
                }, { once: true });

                starterModal.show();
            }
        } else {
            // モーダルが出ない場合はそのままツアーを開始
            setTimeout(() => {
                if (!isTourCompleted && !this.getAttribute('is-demo')) {
                    this.triggerTourGuide();
                }
            }, 500);
        }
    }

    /**
     * ツアーガイドを構築・開始するメソッド（初回＆手動再起動用）
     */
    triggerTourGuide() {
        const tourGuide = this.shadowRoot.querySelector('app-tour-guide');
        if (!tourGuide) return;

        const isMobile = window.innerWidth < 1024;

        // ツアー開始時はパネルを閉じて中央を見せる
        if (isMobile) this.closeAllPanels();

        const steps = [];
        let stepIndex = 1;

        steps.push({
            title: "Pwappyエディターへようこそ",
            icon: "fa-rocket",
            message: "アプリの中身を作れる開発画面です。基本的な画面構成をご案内します。",
            targetSelector: null
        });

        if (isMobile) {
            steps.push({
                title: "💡 パネルの開閉",
                icon: "fa-arrows-left-right",
                message: "スマホ画面では、左右にある「L」や「R」のハンドルを長押ししてドラッグするか、ダブルタップすることで左右のパネルを開閉できます。",
                targetSelector: "#leftMovingHandle",
                position: "bottom"
            });
        }

        steps.push({
            title: `${stepIndex++}. レイアウト`,
            icon: "fa-sitemap",
            message: "画面の構造を管理するパネルです。アプリの骨組みとなるページはここから追加します。",
            targetSelector: "template-container",
            video: "/misc/layout_add_page.webm",
            onShow: () => { if (isMobile) this.openLeftPanel(); }
        });

        if (isMobile) {
            steps.push({
                title: `${stepIndex++}. ツールボックス`,
                icon: "fa-toolbox",
                message: "UI部品（ボタン、リストなど）が揃っています。使いたい部品を長押しして、そのまま上の【レイアウト】枠の中にドラッグ＆ドロップして画面を組み立てます。",
                targetSelector: "tool-box",
                video: "/misc/tool_to_layout.webm",
                onShow: () => { if (isMobile) this.openLeftPanel(); }
            });
        } else {
            steps.push({
                title: `${stepIndex++}. ツールボックス`,
                icon: "fa-toolbox",
                message: "UI部品（ボタン、リストなど）が揃っています。使いたい部品をドラッグして、【レイアウト】枠の中にドロップして画面を組み立てます。",
                targetSelector: "tool-box",
                video: "/misc/tool_to_layout.webm",
                onShow: () => { if (isMobile) this.openLeftPanel(); }
            });
        }

        steps.push({
            title: `${stepIndex++}. プロパティ`,
            icon: "fa-sliders",
            message: "レイアウトで選択した部品の色、サイズ、表示するテキストなどを設定・変更するパネルです。",
            targetSelector: "property-container",
            position: "bottom",
            video: "/misc/property_change.webm",
            onShow: () => { if (isMobile) this.openRightPanel(); }
        });

        steps.push({
            title: `${stepIndex++}. スクリプト`,
            icon: "fa-code",
            message: "ボタンをクリックしたときの動作など、JavaScriptを使ってアプリの動き（ロジック）を記述・割り当てます。",
            targetSelector: "script-container",
            position: "top",
            video: "/misc/script_assign.webm",
            onShow: () => { if (isMobile) this.openRightPanel(); }
        });

        steps.push({
            title: `${stepIndex++}. プレビュー画面`,
            icon: "fa-mobile-screen",
            message: "スマホアプリとしての見た目をプレビュー表示できます。",
            targetSelector: "platform-container",
            position: "bottom",
            onShow: () => { if (isMobile) this.closeAllPanels(); }
        });

        steps.push({
            title: `${stepIndex++}. 表示切替メニュー`,
            icon: "fa-display",
            message: "プレビューのOS（iOS/Android）の切り替えや、ズーム、モード（レイアウト/動作）の切り替えを行います。",
            targetSelector: "platform-switcher",
            position: "bottom",
            onShow: () => { if (isMobile) this.closeAllPanels(); }
        });

        const switcher = this.shadowRoot.querySelector('platform-switcher');
        if (switcher) {
            steps.push({
                title: "設定メニューのアイコン",
                icon: "fa-arrow-pointer",
                message: "このスマホの形をしたアイコンをクリックすると、表示に関する設定メニューが開きます。",
                targetSelector: () => switcher.shadowRoot.querySelector('.screen-rotete-container'),
                position: "bottom",
                onShow: () => { switcher.closeMenu(); } // アイコンだけを強調
            });
            steps.push({
                title: "モードの切り替え",
                icon: "fa-sliders",
                message: "メニューが開きました。一番下の「モード」セクションを確認してください。",
                targetSelector: () => switcher.shadowRoot.getElementById('platformEditMenu'),
                position: "left",
                onShow: () => { switcher.openMenu(); } // ここでメニューをパッと開く
            });
            steps.push({
                title: "設計用の「レイアウト」",
                icon: "fa-drafting-compass",
                message: "【レイアウト】は部品を並べるための設計モードです。編集作業を邪魔しないよう、ボタンなどは反応しません。",
                targetSelector: () => switcher.shadowRoot.querySelector('label[for="mode-layout"]'),
                position: "left"
            });
            steps.push({
                title: "確認用の「動作」",
                icon: "fa-play",
                message: "【動作】モードに切り替えると、実際のアプリと同じようにボタンが反応し、画面遷移を試せるようになります！",
                targetSelector: () => switcher.shadowRoot.querySelector('label[for="mode-action"]'),
                position: "left"
            });
        }

        steps.push({
            title: `${stepIndex++}. メニュー`,
            icon: "fa-bars",
            message: "プロジェクトの保存、ファイル管理、チュートリアル、スナップショットなどのメインメニューです。",
            targetSelector: () => {
                switcher.closeMenu();
                const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                if (bottomMenu && bottomMenu.shadowRoot) {
                    const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');
                    if (menu && menu.style.display !== 'none' && menu.getBoundingClientRect().width > 0) {
                        return menu;
                    }
                }
                return this.shadowRoot.querySelector('platform-bottom-menu');
            },
            position: "top",
            onShow: () => {
                if (isMobile) this.closeAllPanels();
                // AIエージェントの前にメニューが開いていたら一旦閉じる
                const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                if (bottomMenu && bottomMenu.shadowRoot) {
                    const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');
                    if (menu) menu.style.display = 'none';
                }
            }
        });

        // AI機能が有効な場合のみ、追加のステップを挿入
        const isAiEnabled = this.userSettingStore.getState().userSetting.aiCodingEnabled;
        if (isAiEnabled) {
            steps.push({
                title: "AIエージェント",
                icon: "fa-wand-magic-sparkles",
                message: "メニュー内の『AIエージェント』をクリックし、作りたいものを指示するだけで自動でアプリを構築します。",

                targetSelector: () => {
                    const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                    if (bottomMenu && bottomMenu.shadowRoot) {
                        const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');

                        if (menu && menu.style.display !== 'flex') {
                            menu.style.display = 'flex';
                        }

                        const items = bottomMenu.shadowRoot.querySelectorAll('.menu-item');
                        const aiItem = Array.from(items).find(el => el.textContent.includes('AIエージェント'));

                        if (aiItem) {
                            const rect = aiItem.getBoundingClientRect();
                            if (rect.width > 0 && rect.height > 0) {
                                return aiItem;
                            }
                        }
                    }
                    return this.shadowRoot.querySelector('platform-bottom-menu');
                },
                position: "top",
                onShow: () => {
                    if (isMobile) this.closeAllPanels();
                    const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                    if (bottomMenu && bottomMenu.shadowRoot) {
                        const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');
                        if (menu) {
                            menu.style.display = 'flex';
                        }
                    }
                },
                onEnd: () => {
                    if (isMobile) this.closeAllPanels();
                    const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                    if (bottomMenu && bottomMenu.shadowRoot) {
                        const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');
                        if (menu) menu.style.display = 'none';
                    }
                }
            });
        }

        steps.push({
            title: `${stepIndex++}. チュートリアル`,
            icon: "fa-graduation-cap",
            message: "メニューの「チュートリアル」から、いつでも基本操作のツアーや解説動画を確認できます。",
            targetSelector: () => {
                const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                if (bottomMenu && bottomMenu.shadowRoot) {
                    const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');

                    if (menu && menu.style.display !== 'flex') {
                        menu.style.display = 'flex';
                    }

                    const items = bottomMenu.shadowRoot.querySelectorAll('.menu-item');
                    const tutorialItem = Array.from(items).find(el => el.textContent.includes('チュートリアル'));

                    if (tutorialItem) {
                        const rect = tutorialItem.getBoundingClientRect();
                        if (rect.width > 0 && rect.height > 0) {
                            return tutorialItem;
                        }
                    }
                }
                return this.shadowRoot.querySelector('platform-bottom-menu');
            },
            position: "top",
            onShow: () => {
                if (isMobile) this.closeAllPanels();
                const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                if (bottomMenu && bottomMenu.shadowRoot) {
                    const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');
                    if (menu) {
                        menu.style.display = 'flex';
                    }
                }
            },
            onEnd: () => {
                if (isMobile) this.closeAllPanels();
                const bottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');
                if (bottomMenu && bottomMenu.shadowRoot) {
                    const menu = bottomMenu.shadowRoot.getElementById('platformBottomMenu');
                    if (menu) menu.style.display = 'none';
                }
            }
        });
        tourGuide.startTour(steps);
    }

    disconnectedCallback() {
        window.removeEventListener('gesturestart', this._blockNativeZoom);
        window.removeEventListener('gesturechange', this._blockNativeZoom);
        window.removeEventListener('open-tutorial', this.boundHandleOpenTutorial);
        window.removeEventListener('restart-tour', this.boundHandleRestartTour);
        window.removeEventListener('apply-starter-template', this.boundHandleApplyStarterTemplate);
        window.removeEventListener('open-ai-agent-window', this.boundHandleOpenAIAgentWindow);

        // グローバルD&Dリスナー解除
        window.removeEventListener('app-drag-start', this._boundHandleAppDragStart);
        window.removeEventListener('app-drag-end', this._boundHandleAppDragEnd);
        window.removeEventListener('touchmove', this._boundHandleGlobalDragMove);
        window.removeEventListener('mousemove', this._boundHandleGlobalDragMove);

        super.disconnectedCallback();
    }

    handleAppDragStart() {
        // レイアウトウィンドウからのドラッグ (dragItemType が 'node-id') の時のみ、
        // エッジトリガーを有効にする（ツールボックスからのドラッグ時は無視）
        if (window.dragItemType === 'node-id') {
            this.isGlobalDragging = true;
        }
    }

    handleAppDragEnd() {
        this.isGlobalDragging = false;
        this.dragHoverEdge = null;
        if (this._edgeTimer) {
            clearTimeout(this._edgeTimer);
            this._edgeTimer = null;
        }
    }

    handleGlobalDragMove(e) {
        // PC（画面幅1024以上）またはドラッグ中でない場合は何もしない
        if (!this.isGlobalDragging || window.innerWidth >= 1024) return;

        let clientX, clientY;
        if (e.touches && e.touches.length > 0) {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
        } else {
            clientX = e.clientX;
            clientY = e.clientY;
        }

        const edgeWidth = 40;
        const windowWidth = window.innerWidth;
        let currentEdge = null;

        // 右端（右パネルを開きたい時）
        if (clientX > windowWidth - edgeWidth) {
            // 右パネルが閉じているか判定（右ハンドルの位置が画面幅の半分より右にあるか）
            const rightHandle = this.shadowRoot.querySelector('#rightMovingHandle');
            if (rightHandle) {
                const rect = rightHandle.getBoundingClientRect();
                if (rect.left > windowWidth / 2) {
                    currentEdge = 'right';
                }
            }
        }
        // 左端（左パネルを開きたい時）
        else if (clientX < edgeWidth) {
            // 左パネルが閉じているか判定（左ハンドルの位置が画面幅の半分より左にあるか）
            const leftHandle = this.shadowRoot.querySelector('#leftMovingHandle');
            if (leftHandle) {
                const rect = leftHandle.getBoundingClientRect();
                if (rect.left < windowWidth / 2) {
                    currentEdge = 'left';
                }
            }
        }

        if (this.dragHoverEdge !== currentEdge) {
            this.dragHoverEdge = currentEdge;
            if (this._edgeTimer) {
                clearTimeout(this._edgeTimer);
                this._edgeTimer = null;
            }

            if (currentEdge) {
                // ホバー開始。一定時間(800ms)後にパネルを開く
                this._edgeTimer = setTimeout(() => {
                    if (this.dragHoverEdge === 'right') {
                        this.openRightPanel();
                    } else if (this.dragHoverEdge === 'left') {
                        this.openLeftPanel();
                    }
                    this.dragHoverEdge = null; // 開いた後はホバー状態を解除
                }, 800);
            }
        }
    }

    /**
     * 全てのユーザースクリプトをパースし、Toolboxコンポーネントを同期します。
     */
    syncAllUserScriptsToToolbox() {
        const scripts = this.scriptItemStore.getState().scriptItems.scripts;
        if (scripts && scripts.length > 0) {
            scripts.forEach(script => {
                const scriptCode = script.scriptValue.join('\n');

                try {
                    // 1. スクリプトからWeb Component定義をすべて取得
                    const definitions = findCustomElementDefinitions(scriptCode);
                    if (definitions.length === 0) return; // 定義がなければ次へ

                    // 2. スクリプト全体の宣言情報を取得（コメント取得用）
                    const allDeclarations = extractDeclarationInfo(scriptCode);

                    // 3. 各Web Componentをループして、個別にストアを更新
                    definitions.forEach(def => {
                        const { tagName, className, jsdoc } = def;
                        const componentComment = allDeclarations[className]?.comment || "";

                        // --- Toolboxストアの更新 ---
                        this.toolBoxItemStore.dispatch(syncUserScriptComponent({
                            originScriptName: script.scriptName, // 由来のスクリプト名
                            tagName: tagName,                    // WCのタグ名
                            comment: componentComment,           // WCのコメント
                        }));

                        // --- Attribute/Eventストアの更新 ---
                        // idTypeCommentを生成・登録
                        const idTypeComment = `/** @type{${className}} */`;
                        this.attributeItemStore.dispatch(setIdTypeCommentForTag({ tagName, idTypeComment }));

                        // JSDocをパースして属性とイベントを取得
                        const { attributes, events } = parseJSDoc(jsdoc);

                        // 属性を登録（既存チェック付き）
                        const existingAttributes = selectAttributeByTagName(this.attributeItemStore.getState(), tagName);
                        attributes.forEach(attr => {
                            const attributeExists = existingAttributes.some(ex => Object.keys(ex)[0] === attr.name);
                            if (!attributeExists) {
                                const attributePayload = { [attr.name]: { inputName: attr.inputName, inputType: attr.inputType, options: attr.options, comment: attr.comment, registerType: 'customScript', originScriptName: script.scriptName } };
                                const tagExists = this.attributeItemStore.getState().attributeItems.items.some(i => i.tagName === tagName);
                                if (!tagExists) this.attributeItemStore.dispatch(addNewTag({ tagName, attributes: [] }));
                                this.attributeItemStore.dispatch(addAttributeToExistingTag({ tagName, attribute: attributePayload }));
                            }
                        });

                        // イベントを登録
                        const existingEvents = selectEventByTagName(this.eventItemStore.getState(), tagName);
                        events.forEach(event => {
                            const eventExists = existingEvents.some(ex => Object.keys(ex)[0] === event.name);
                            if (!eventExists) {
                                const eventPayload = { [event.name]: { listenerTarget: "element", scripts: [], comment: event.comment, registerType: 'customScript', originScriptName: script.scriptName } };
                                const tagExists = this.eventItemStore.getState().eventItems.items.some(i => i.tagName === tagName);
                                if (!tagExists) this.eventItemStore.dispatch(addNewEventTag({ tagName, events: [] }));
                                this.eventItemStore.dispatch(addEventToExistingTag({ tagName, event: eventPayload }));
                            }
                        });
                    });
                } catch (e) {
                    console.error(`スクリプト "${script.scriptName}" の初期解析に失敗しました:`, e);
                }
            });
        }
    }

    /**
     * スクリプトコードからcustomElements.defineのタグ名配列を抽出します。
     * @param {string} code - スクリプトのコード
     * @returns {string[]} - 抽出されたタグ名の配列
     */
    parseDefinedTags(code) {
        const regex = /customElements\.define\s*\(\s*['"]([^'"]+)['"]\s*,/g;
        const matches = code.matchAll(regex);
        const tags = [];
        for (const match of matches) {
            tags.push(match[1]);
        }
        return tags;
    }

    async importPlatformSwitcher() {
        if (!this.platformSwitcher) {
            const platformSwitcher = await import('./PlatformSwitcher.js');
            this.platformSwitcher = platformSwitcher.default;
        }
        return Promise.resolve();
    }

    // beforeunload イベントのハンドラー
    async handleBeforeUnload(e) {
        // タブを閉じる直前にスナップショットを作成
        await SnapshotController.createSnapshot(
            "自動保存 - 未保存",
            `タブを閉じる直前の状態です。 (${new Date().toLocaleString()})`
        );
        e.preventDefault();
        e.returnValue = 'ページを離れます よろしいですか？';
    }

    // 警告を有効にする関数
    enableCloseWarning() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    // 警告を無効にする関数
    disableCloseWarning() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleShowFileExplorerEvent(e) {
        //fiel-explorerを取得
        const fileExplorer = this.shadowRoot.querySelector('file-explorer');
        //const fileExplorer = this.fileExplorer;
        //URLパラメータからappKeyを取得
        const appKey = new URLSearchParams(window.location.search).get('appKey');
        fileExplorer.currentPath = '/' + appKey;
        fileExplorer.show();
    }

    async compressAndEncodeBase64(editorJson) {
        const cs = new CompressionStream('gzip'); // 圧縮ストリームを作成
        const writer = cs.writable.getWriter();   // ストリームの書き込み可能部分を取得
        const encoder = new TextEncoder();        // 文字列をUint8Arrayにエンコードするためのエンコーダ

        // JSONデータを文字列化し、UTF-8エンコードして圧縮ストリームに書き込む
        writer.write(encoder.encode(JSON.stringify(editorJson)));
        writer.close(); // ストリームを閉じて圧縮処理を完了させる

        const chunks = [];
        const reader = cs.readable.getReader(); // ストリームの読み込み可能部分を取得

        // 圧縮されたデータをチャンク（Uint8Arrayの配列）として読み込む
        let result;
        while (!(result = await reader.read()).done) {
            chunks.push(result.value);
        }

        // 複数のUint8Arrayチャンクを一つのUint8Arrayに効率的に結合
        // まず全体の長さを計算
        let totalLength = 0;
        for (const chunk of chunks) {
            totalLength += chunk.length;
        }

        // 全体の長さを持つ新しいUint8Arrayを作成
        const compressed = new Uint8Array(totalLength);
        let offset = 0;
        // 各チャンクを新しいUint8Arrayにコピー
        for (const chunk of chunks) {
            compressed.set(chunk, offset);
            offset += chunk.length;
        }

        // Uint8ArrayをBase64にエンコード（FileReader APIを使用）
        // RangeError: Maximum call stack size exceeded を回避する最も一般的な方法
        return new Promise((resolve, reject) => {
            // Uint8ArrayをBlobオブジェクトに変換
            // 'application/octet-stream' は一般的なバイナリデータのMIMEタイプ
            const blob = new Blob([compressed], { type: 'application/octet-stream' });
            const fileReader = new FileReader(); // FileReaderインスタンスを作成

            // 読み込み完了時のイベントハンドラを設定
            fileReader.onloadend = () => {
                // fileReader.result には Data URL 形式の文字列が格納される
                // 例: "data:application/octet-stream;base64,H4sIA..."
                // "base64,"以降の部分が純粋なBase64文字列なので、これを抽出して解決する
                const base64String = fileReader.result.split(',')[1];
                resolve(base64String);
            };

            // エラー発生時のイベントハンドラを設定
            fileReader.onerror = (error) => {
                reject(error); // Promiseを拒否
            };

            // BlobをData URLとして読み込みを開始
            fileReader.readAsDataURL(blob);
        });
    }

    async handleEditorJsonSaveEvent(event) {
        try {
            this.loading = true;

            //urlパラメータからapplicationKeyとversionを取得
            const urlParams = new URLSearchParams(window.location.search);
            const appKey = urlParams.get('appKey');
            const version = urlParams.get('version');

            let currentVersion = this.editorJsonVersionStore.getState().editorJsonVersion.currentVersion;

            // Promise.allを使用して、全てのキーに対して非同期処理を並行して実行する
            const promises = [
                this.compressAndEncodeBase64(this.appSettingStore.getState().appSetting),
                this.compressAndEncodeBase64(this.attributeItemStore.getState().attributeItems.items),
                this.compressAndEncodeBase64(this.eventItemStore.getState().eventItems.items),
                this.compressAndEncodeBase64(this.scriptItemStore.getState().scriptItems),
                this.compressAndEncodeBase64(this.serviceWorkerItemStore.getState().serviceworkerItems.items),
                this.compressAndEncodeBase64(this.templateJsonStore.getState().templateJson),
                this.compressAndEncodeBase64(this.toolBoxItemStore.getState().toolboxItems.customItems),
                this.compressAndEncodeBase64(this.testItemStore.getState().testItems)
            ];

            // Promise.allを使用して、全てのプロミスが解決されるのを待つ
            const [
                appSettings,
                attributeItems,
                eventItems,
                scriptItems,
                serviceWorkerItems,
                templateItems,
                toolBoxItems,
                testItems
            ] = await Promise.all(promises);

            const data = {
                appKey: appKey,
                version: version,
                editorJson: {
                    appSettings: appSettings,
                    attributeItems: attributeItems,
                    editorJsonVersion: currentVersion,
                    eventItems: eventItems,
                    scriptItems: scriptItems,
                    serviceWorkerItems: serviceWorkerItems,
                    templateItems: templateItems,
                    toolBoxItems: toolBoxItems,
                    testItems: testItems,
                }
            }


            // fetchオプションを設定
            const options = {
                method: 'PUT',
                body: JSON.stringify(data),
            }

            const endpoint = process.env.EDITOR_JSON_ENDPOINT;
            let response = await this.fetchWithAuth(endpoint, options);
            if (response.code === 200) {
                await this.reloadEditorJson();

                // 保存が正常に完了したため、状態シグネチャを最新データで更新
                this._updateSavedStateSignature();

                // スクリプトエディタ側の「未保存」表示用の内部状態もリセット
                const scriptContainer = this.shadowRoot.querySelector('script-container');
                if (scriptContainer && scriptContainer.isEditorActive) {
                    scriptContainer.isChangedEditorValue = false;
                    if (scriptContainer.styleEditor) {
                        scriptContainer.editorInitialValue = scriptContainer.styleEditor.getValue();
                    }
                }
                //alertStore.dispatch(setAlert('保存しました'));
            } else {
                alertStore.dispatch(setAlert(response.message));
                throw new Error(response.message);
            }

            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        } finally {
            this.loading = false;
        }
    }

    async handleEditorJsonSaveAndCloseEvent(event) {
        try {
            await this.handleEditorJsonSaveEvent(event);
            await SnapshotController.clearSnapshotsForCurrentProject();
            this.disableCloseWarning();
            if (window.opener) {
                window.close()
            } else {
                alert('この画面を自動的に閉じることができないので手動で閉じてください');
            }
        } catch (error) {
            return;
        }
    }

    _getCurrentStateSignature() {
        try {
            return JSON.stringify({
                appSetting: this.appSettingStore.getState().appSetting,
                attributeItems: this.attributeItemStore.getState().attributeItems.items,
                eventItems: this.eventItemStore.getState().eventItems.items,
                scriptItems: this.scriptItemStore.getState().scriptItems,
                serviceworkerItems: this.serviceWorkerItemStore.getState().serviceworkerItems.items,
                templateJson: this.templateJsonStore.getState().templateJson,
                toolBoxItems: this.toolBoxItemStore.getState().toolboxItems.customItems,
                testItems: this.testItemStore.getState().testItems
            });
        } catch (e) {
            return null;
        }
    }

    // 状態を現在のデータで更新保存する
    _updateSavedStateSignature() {
        this._savedStateSignature = this._getCurrentStateSignature();
    }

    // 未保存の変更（履歴、あるいはスクリプトエディタ等）があるかを調べる判定メソッド
    // 実際に未保存のデータ変更があるかを高精度に判定するメソッド
    hasUnsavedChanges() {
        // 1. スクリプトエディタ自体で未保存の編集（キー入力中など）があるか
        const scriptContainer = this.shadowRoot.querySelector('script-container');
        if (scriptContainer && scriptContainer.isChangedEditorValue) {
            return true;
        }

        // 2. 現在の各データストアの状態が、前回保存された時の状態と異なるか
        if (this._savedStateSignature !== null) {
            const currentSignature = this._getCurrentStateSignature();
            if (this._savedStateSignature !== currentSignature) {
                return true;
            }
        }

        return false;
    }

    async handleEditorJsonCloseEvent(event) {
        // 本当に未保存の変更がある場合のみ、確認メッセージを表示する
        if (this.hasUnsavedChanges()) {
            const confirmClose = confirm("未保存の変更があります。本当に保存せずに閉じますか？");
            if (!confirmClose) {
                return; // 閉じる操作をキャンセル
            }
        }

        await SnapshotController.clearSnapshotsForCurrentProject();
        this.disableCloseWarning(); // 警告を無効にしてから閉じる
        if (window.opener) {
            window.close()
        } else {
            alert('この画面を自動的に閉じることができないので手動で閉じてください');
        }
    }

    /**
     * app-editorを表示して初期化
     */
    handleShowEditScreen() {
        //すべてのcomponentクラスを非表示にする
        this.shadowRoot.querySelectorAll('.component').forEach(element => {
            element.style.display = 'none';
        });

        //id="app-editor"を表示にする
        this.shadowRoot.querySelector('#app-editor').style.display = 'flex';
        this.initEditorDisplay();
    }

    /**
     * ツールボックスアイテム編集画面の表示
     * @param {*} e 
     */
    handleShowToolBoxItemEditorEvent(e) {
        const editor = this.shadowRoot.querySelector('tool-box-item-editor');
        editor.show();
    }

    /**
     * ツールボックスアイテムの追加
     * @param {*} e 
     */
    handleToolBoxItemAdd(e) {
        let componentName = e.detail.componentName;
        let componentTag = e.detail.componentTag;

        let component = findByComponentName(this.toolBoxItemStore.getState(), componentName);
        if (!component) {
            component = findByCustomComponentName(this.toolBoxItemStore.getState(), componentName);
        }
        try {
            // componentがあればエラー
            if (component) throw new Error("すでに登録されているコンポーネント名です");

            //componentTagがスペースで区切れる場合は配列にする
            componentTag = componentTag.split(' ');

            let componentCode = e.detail.componentCode;

            const json = htmlToJson(componentCode);
            this.toolBoxItemStore.dispatch(addToolBoxItem(
                {
                    "groupName": "User Component",
                    "componentName": componentName,
                    "filter-tag": componentTag,
                    "component": {
                        "tagName": json.tagName,
                        "explain": json.explain || '',
                        "text": json.text || '',
                        "domId": json.domId || undefined,
                        "attributes": json.attributes,
                        "children": json.children
                    }
                })
            );
            e.detail.eventSource.hide();
        } catch (e) {
            alertStore.dispatch(setAlert(e.message));
        }
    }

    /**
     * ツールボックスアイテムの編集
     * @param {*} e 
     */
    handleToolBoxItemEdit(e) {
        const originComponentName = e.detail.originComponentName;
        const componentName = e.detail.componentName;
        let componentTag = e.detail.componentTag;

        const component = findByCustomComponentName(this.toolBoxItemStore.getState(), originComponentName);
        try {
            // componentがなければエラー
            if (!component) throw new Error("編集できないコンポーネントです");

            //新しいコンポーネント名がすでに存在していたらエラー
            const sysComponent = findByComponentName(this.toolBoxItemStore.getState(), componentName);
            const userComponent = findByCustomComponentName(this.toolBoxItemStore.getState(), componentName);
            if (originComponentName !== componentName) {
                if (sysComponent || userComponent) throw new Error('使用できないコンポーネント名です');
            }

            //componentTagがスペースで区切れる場合は配列にする
            componentTag = componentTag.split(' ');

            let componentCode = e.detail.componentCode;

            const json = htmlToJson(componentCode);
            this.toolBoxItemStore.dispatch(updateToolBoxItem(
                {
                    "groupName": "User Component",
                    "originComponentName": originComponentName,
                    "componentName": componentName,
                    "filter-tag": componentTag,
                    "component": {
                        "tagName": json.tagName,
                        "explain": json.explain || '',
                        "text": json.text || '',
                        "domId": json.domId || undefined,
                        "attributes": json.attributes,
                        "children": json.children
                    }
                })
            );
            e.detail.eventSource.hide();
        } catch (e) {
            alertStore.dispatch(setAlert(e.message));
        }
    }

    /**
     * ツールボックスアイテムの削除
     * @param {*} e 
     */
    handleToolBoxItemDelete(e) {
        const componentName = e.detail.componentName;

        const component = findByCustomComponentName(this.toolBoxItemStore.getState(), componentName);
        try {
            // componentがなければエラー
            if (!component) throw new Error("削除できないコンポーネントです");

            this.toolBoxItemStore.dispatch(deleteToolBoxItem(
                {
                    "componentName": componentName,
                })
            );
            e.detail.eventSource.hide();
        } catch (e) {
            alertStore.dispatch(setAlert(e.message));
        }
    }

    /**
     * ツールボックスアイテムの編集開始
     * @param {*} e 
     */
    handleBeginToolBoxItemEdit(e) {
        let componentName = e.detail.componentName;
        const component = findByCustomComponentName(this.toolBoxItemStore.getState(), componentName);
        try {
            // componentがなければエラー
            if (!component) throw new Error("編集できないコンポーネントです");
            const editor = this.shadowRoot.querySelector('tool-box-item-editor');

            const html = jsonToHtml(component.component);
            editor.componentName = component.componentName;
            editor.componentTags = component['filter-tag'].join(' ');
            editor.componentCode = html;
            editor.show('edit', componentName);
        } catch (e) {
            alertStore.dispatch(setAlert(e.message));
        }
    }

    /**
     * テンプレートからツールボックスへのアイテムの追加開始
     * @param {*} e 
     */
    handleBeginToolBoxItemFromTemplate(e) {

        const templateItemId = e.detail.templateItemId;
        if (templateItemId) {
            try {
                const templateItem = findElementById(this.templateJsonStore.getState().templateJson, templateItemId);

                const editor = this.shadowRoot.querySelector('tool-box-item-editor');
                const html = templateItemToHtml(templateItem);
                editor.componentCode = html;
                editor.show();
            } catch (e) {
                alertStore.dispatch(setAlert(e.message));
            }
        }
    }

    handleOpenAICoderWindow(e) {
        const aiCoderWindow = this.shadowRoot.querySelector('ai-coder-window');

        const aboveLineText = e.detail?.aboveLineText;
        const targetScriptName = e.detail?.targetScriptName;
        const targetScriptValue = e.detail?.targetScriptValue;
        const mode = e.detail?.mode;

        aiCoderWindow.prompt = '';
        aiCoderWindow.targetScriptName = '';
        aiCoderWindow.targetScriptValue = '';
        aiCoderWindow.mode = 'javascript';

        if (aboveLineText) {
            aiCoderWindow.prompt = aboveLineText + '\n' + '上のコメントに対応するコードを作成';
        } else {
            aiCoderWindow.prompt = '';
        }
        if (targetScriptName) {
            aiCoderWindow.targetScriptName = targetScriptName;
        }
        if (targetScriptValue) {
            aiCoderWindow.targetScriptValue = targetScriptValue;
        }
        if (mode) {
            aiCoderWindow.mode = mode;
        }
        aiCoderWindow.show();
    }

    // 起動時のスナップショットチェック処理
    async checkForOrphanedSnapshots() {
        const snapshots = await SnapshotController.getSnapshotsForCurrentProject();
        if (snapshots && snapshots.length > 0) {
            const messageBox = document.createElement('message-box');
            this.shadowRoot.appendChild(messageBox);

            const messageSlot = document.createElement('div');
            messageSlot.slot = 'message-slot';
            messageSlot.innerHTML = `
                <p>前回正常に終了されなかった可能性のある変更（スナップショット）が見つかりました。</p>
                <p>最新のスナップショットから状態を復元しますか？</p>
                <p style="font-size:0.8em; color:gray;">「破棄」を選択すると、保存されていたスナップショットはすべて削除されます。</p>
            `;

            const okButton = document.createElement('button');
            okButton.slot = 'ok-slot';
            okButton.classList.add('snapshot-button');
            okButton.textContent = '復元する';

            const cancelButton = document.createElement('button');
            cancelButton.slot = 'cancel-slot';
            cancelButton.classList.add('snapshot-button');
            cancelButton.classList.add('red');
            cancelButton.textContent = '破棄する';

            messageBox.appendChild(messageSlot);
            messageBox.appendChild(okButton);
            messageBox.appendChild(cancelButton);

            const confirmed = await messageBox.show();

            if (confirmed) { // 「復元する」
                await SnapshotController.restoreSnapshot(snapshots[0].id); // 最新は配列の先頭
                this.templateSelectedRootStore.dispatch(resetRoot());
                alert('状態を復元しました。');
            } else { // 「破棄する」
                const confirmDiscardMessageBox = document.createElement('message-box');
                confirmDiscardMessageBox.innerHTML = `
                    <div slot="message-slot">
                        <p class="caution" style="font-size: 50px; display: flex; justify-content: space-around; color: #e7c200;"><i class="fa-solid fa-triangle-exclamation"></i></p>
                        <p style="text-align: center;">すべてのスナップショットを破棄しますか？</p>
                        <p style="text-align: center; font-size: 0.8em; color: gray;">この操作は元に戻せません。</p>
                    </div>
                    <button class="snapshot-button red" slot="ok-slot">はい、破棄します</button>
                    <button class="snapshot-button gray"slot="cancel-slot" class="confirm-cancel-button">キャンセル</button>
                `;
                this.shadowRoot.appendChild(confirmDiscardMessageBox);
                const reallyDiscard = await confirmDiscardMessageBox.show();

                if (reallyDiscard) {
                    await SnapshotController.clearAllExcept(["自動保存 - エディタ読み込み完了"]);
                    alert('不要なスナップショットを破棄しました。');
                } else {
                    alert('スナップショットの破棄をキャンセルしました。');
                }
                confirmDiscardMessageBox.remove(); // 確認メッセージボックスを削除
            }
            messageBox.remove();
        }
    }

    // スナップショットマネージャー表示ハンドラ
    handleShowSnapshotManager() {
        const manager = this.shadowRoot.querySelector('snapshot-manager');
        if (manager) {
            manager.show();
        }
    }

    // チュートリアルモーダル表示ハンドラ
    handleOpenTutorial(e) {
        let modal = this.shadowRoot.querySelector('app-tutorial-modal');
        if (!modal) {
            modal = document.createElement('app-tutorial-modal');
            modal.id = 'tutorial-modal';
            this.shadowRoot.appendChild(modal);
        }

        const videoId = e.detail && e.detail.videoId ? e.detail.videoId : null;
        modal.show(videoId);
    }

    async reloadEditorJson() {
        let data = await editorDataStore.dispatch(fetchDataForEditorStores().bind(this))
        try {
            const appSettings = data.payload.appSettings;
            if (appSettings && appSettings.length !== 0) {
                this.appSettingStore.dispatch(this.appSettingSlice.loadAppSettingData(appSettings));
            }

            const attributeItems = data.payload.attributeItems;
            if (attributeItems && attributeItems.length !== 0) {
                this.attributeItemStore.dispatch(this.attributeItemSlice.loadAttributeItemData(attributeItems));
            }

            const editorJsonVersion = data.payload.editorJsonVersion;
            if (editorJsonVersion) {
                this.editorJsonVersionStore.dispatch(this.editorJsonVersionSlice.loadCurrentVersion(editorJsonVersion));
            }

            const eventItems = data.payload.eventItems;
            if (eventItems && eventItems.length !== 0) {
                this.eventItemStore.dispatch(this.eventItemSlice.loadEventItemData(eventItems));
            }

            const scriptItems = data.payload.scriptItems;
            if (scriptItems && scriptItems.length !== 0) {
                this.scriptItemStore.dispatch(this.scriptItemSlice.loadScriptData(scriptItems));
            }

            const serviceWorkerItems = data.payload.serviceWorkerItems;
            if (serviceWorkerItems && serviceWorkerItems.length !== 0) {
                this.serviceWorkerItemStore.dispatch(this.serviceWorkerItemSlice.loadServiceWorkerItemData(serviceWorkerItems));
            }

            const templateItems = data.payload.templateItems;
            if (templateItems && templateItems.length !== 0) {
                this.templateJsonStore.dispatch(this.templateJsonSlice.loadTemplateJson(templateItems));
            }

            const toolBoxItems = data.payload.toolBoxItems;
            if (toolBoxItems && toolBoxItems.length !== 0) {
                this.toolBoxItemStore.dispatch(this.toolBoxItemSlice.loadToolBoxCustomData(toolBoxItems));
            }

            const testItems = data.payload.testItems;
            if (testItems && Object.keys(testItems).length !== 0) {
                this.testItemStore.dispatch(this.testItemSlice.loadTestData(testItems));
            }

            // // 選択済みのテンプレートをリセット
            // templateSelectedRootStore.dispatch(resetRoot());
            // templateSelectedItemStore.dispatch(deselectItem());
        } catch (e) {
            return Promise.reject(e);
        } finally {
            this.loading = false;
        }
        return Promise.resolve(data);
    }

    callbackPlatformStore() {
        this.platformCenterMove();
    }

    handleWindowResize() {
        this.moveLeftHandle();
        this.moveRightHandle();
    }

    // パネル開閉制御メソッド
    openLeftPanel() {
        if (window.innerWidth >= 1024) return;
        this.leftMovingHandleX = window.innerWidth;
        this.rightMovingHandleX = window.innerWidth;
        this.moveLeftHandle(); this.moveRightHandle();
    }

    openRightPanel() {
        if (window.innerWidth >= 1024) return;
        this.rightMovingHandleX = 0;
        this.leftMovingHandleX = 0;
        this.moveLeftHandle(); this.moveRightHandle();
    }

    closeAllPanels() {
        if (window.innerWidth >= 1024) return;
        const rightHandle = this.shadowRoot.querySelector('#rightMovingHandle');
        const handleWidth = rightHandle ? rightHandle.getBoundingClientRect().width : 25;
        this.leftMovingHandleX = 0;
        this.rightMovingHandleX = window.innerWidth - handleWidth;
        this.moveLeftHandle(); this.moveRightHandle();
    }

    platformCenterMove() {
        window.requestAnimationFrame(() => {
            const platformContainer = this.shadowRoot.querySelector('platform-container');
            const platformBackground = this.shadowRoot.querySelector('platform-background');
            if (platformContainer && platformBackground) {
                const windowWidth = window.innerWidth;
                const windowHeight = window.innerHeight;
                const platformRect = platformContainer.getBoundingClientRect();
                const platformScale = platformStore.getState().platform.scale;
                let platformWidth = 0;
                let platformHeight = 0;
                if (platformStore.getState().platform.orientation === 'portrait') {
                    platformHeight = platformStore.getState().platform.height;
                    platformWidth = platformStore.getState().platform.width;
                } else {
                    platformHeight = platformStore.getState().platform.width;
                    platformWidth = platformStore.getState().platform.height;
                }

                // 現在のプレビューのサイズを特定（未描画時はデフォルト値をフォールバック）
                const paddingOffset = (platformStore.getState().platform.os === 'ios' ? 14 : 12) * 2;
                const currentHeight = platformRect.height > 0 ? platformRect.height : (platformHeight + paddingOffset);
                const currentWidth = platformRect.width > 0 ? platformRect.width : (platformWidth + paddingOffset);
                const hasRealSize = platformRect.height > 0;
                const scaleFactor = hasRealSize ? 1 : (platformScale / 100);

                const platform = platformStore.getState().platform;

                // パネルの幅（ハンドル位置）にプレビュー位置を左右されないよう、基準点を常に「画面物理中央」に完全固定します。
                // これにより、ハンドル操作をしてもプレビューは一切動かず、裏での計算ズレも発生しなくなります。
                const baseCenterX = windowWidth / 2;
                const baseCenterY = windowHeight / 2;

                const centerX = baseCenterX + platform.x;
                const centerY = baseCenterY + platform.y;

                // プレビューの左上角の座標 (中心からサイズ半分を引く)
                const topVal = centerY - (currentHeight * scaleFactor) / 2;
                const leftVal = centerX - (currentWidth * scaleFactor) / 2;

                platformContainer.style.top = topVal + 'px';
                platformContainer.style.left = leftVal + 'px';
            } else {
                console.warn(`[AppContainer] Missing target elements: platformContainer=${!!platformContainer}, platformBackground=${!!platformBackground}`);
            }
        });
    }

    initEditorDisplay() {
        window.requestAnimationFrame(() => {
            // 表示領域の縦横のサイズを取得する
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            const leftMovingHandle = this.shadowRoot.querySelector('#leftMovingHandle');
            const rightMovingHandle = this.shadowRoot.querySelector('#rightMovingHandle');

            // 横サイズ 1024 未満の時のサイズ/スケールディスパッチは connectedCallback に移したため、
            // ここでは純粋にハンドルの初期位置（位置決め）の処理のみを実行します。
            if (windowWidth < 1024) {
                //leftMovingHandleの初期位置を画面中央よりleftMovingHandleの高さだけ足した値にする
                this.leftMovingHandleY = windowHeight / 2 + leftMovingHandle.getBoundingClientRect().height / 2;
                //movingHandleの横位置は表示領域のleftから25％の位置
                this.leftMovingHandleX = 0;

                //rightMovingHandleの初期位置を画面中央よりrightMovingHandleの高さだけ引いた値にする
                this.rightMovingHandleY = windowHeight / 2 - rightMovingHandle.getBoundingClientRect().height / 2;
                //movingHandleの横位置は画面サイズ
                this.rightMovingHandleX = windowWidth;

                let mobileWidth = windowWidth - 183;

                // 同様に上限値を 320px に制限します。
                if (mobileWidth > 320) {
                    mobileWidth = 320;
                }

                let mobileHeight = mobileWidth * 20 / 9;
                mobileWidth = Math.floor(mobileWidth);
                mobileHeight = Math.floor(mobileHeight);
                platformStore.dispatch(changePlatformSize({ width: mobileWidth, height: mobileHeight }));
                platformStore.dispatch(changeScale(100));
            } else {
                //leftMovingHandleの初期位置を設定

                if (leftMovingHandle) {
                    //leftMovingHandleの縦位置は表示領域の50％からmovingHandleの高さの半分を引いた箇所
                    this.leftMovingHandleY = windowHeight * 0.5 - leftMovingHandle.getBoundingClientRect().height / 2;
                    //movingHandleの横位置は表示領域のleftから25％の位置
                    this.leftMovingHandleX = windowWidth * 0.25;
                }


                //rightMovingHandleの初期位置を設定

                if (rightMovingHandle) {
                    //rightMovingHandleの縦位置は表示領域の50％からmovingHandleの高さの半分を引いた箇所
                    this.rightMovingHandleY = windowHeight * 0.5 - rightMovingHandle.getBoundingClientRect().height / 2;
                    //movingHandleの横位置は表示領域のrightから25％の位置
                    this.rightMovingHandleX = windowWidth * 0.75;
                }
            }

            this.moveLeftHandle();
            this.moveRightHandle();

            //leftMovingHandleにタッチイベントとダブルクリックイベントを追加
            leftMovingHandle.addEventListener('touchstart', this.handleLeftTouchStart.bind(this), false);
            leftMovingHandle.addEventListener('touchend', this.handleLeftTouchEnd.bind(this), false);
            leftMovingHandle.addEventListener('touchmove', this.handleLeftTouchMove.bind(this), false);
            leftMovingHandle.addEventListener('dblclick', this._boundToggleLeftPanel, false);

            //rightMovingHandleにタッチイベントとダブルクリックイベントを追加
            rightMovingHandle.addEventListener('touchstart', this.handleRightTouchStart.bind(this), false);
            rightMovingHandle.addEventListener('touchend', this.handleRightTouchEnd.bind(this), false);
            rightMovingHandle.addEventListener('touchmove', this.handleRightTouchMove.bind(this), false);
            rightMovingHandle.addEventListener('dblclick', this._boundToggleRightPanel, false);

            this.platformCenterMove();
        });
    }

    async firstUpdated() {
        await this.updateComplete;
        window.addEventListener('resize', this.handleWindowResize.bind(this));
        this.initEditorDisplay();
    }

    async importPropertyContainer() {
        if (!this.propertyContainer) {
            const propertyContainer = await import('./PropertyContainer');
            this.propertyContainer = propertyContainer;
        }
        return Promise.resolve();
    }

    async importScriptContainer() {
        if (!this.scriptContainer) {
            const scriptContainer = await import('./ScriptContainer.js');
            this.scriptContainer = scriptContainer;
        }
        return Promise.resolve();
    }

    /**
     * 左側ハンドルを動かしたときに呼び出す関数
     */
    async moveLeftHandle() {
        //表示領域の縦横のサイズを取得する
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        const leftMovingHandle = this.shadowRoot.querySelector('#leftMovingHandle');
        if (leftMovingHandle) {

            //handleのtopが画面サイズより下になる場合は画面サイズ＋handleの高さで止める
            if (this.leftMovingHandleY > window.innerHeight - leftMovingHandle.getBoundingClientRect().height) {
                this.leftMovingHandleY = window.innerHeight - leftMovingHandle.getBoundingClientRect().height;
            }

            //handleのleftが0より小さくなる場合は0で止める
            if (this.leftMovingHandleX < 0) {
                this.leftMovingHandleX = 0;
            }

            if (this.leftMovingHandleY < 0) {
                this.leftMovingHandleY = 0;
            }

            //handleのleftが画面サイズより大きくなる場合は画面サイズ＋handleの幅で止める
            if (this.leftMovingHandleX > window.innerWidth - leftMovingHandle.getBoundingClientRect().width) {
                this.leftMovingHandleX = window.innerWidth - leftMovingHandle.getBoundingClientRect().width;
            }

            leftMovingHandle.style.top = this.leftMovingHandleY + "px";
            leftMovingHandle.style.left = this.leftMovingHandleX + "px";

            //leftMovingHandleの縦方向の中央位置を取得
            const leftMovingHandleCenterY = leftMovingHandle.getBoundingClientRect().top + leftMovingHandle.getBoundingClientRect().height / 2;
            //leftMovingHandleの高さを取得
            const leftMovingHandleHeight = leftMovingHandle.getBoundingClientRect().height;

            //leftMovingHandleの横方向の中央位置を取得
            const leftMovingHandleCenterX = leftMovingHandle.getBoundingClientRect().left - leftMovingHandle.getBoundingClientRect().width / 2;
            //leftMovingHandleの幅を取得
            const leftMovingHandleWidth = leftMovingHandle.getBoundingClientRect().width;

            const templateContainer = this.shadowRoot.querySelector('template-container');
            if (templateContainer) {
                // rightMovingHandleCenterYが画面の上部から30pxの範囲であれば、property-containerにdisplay:noneのスタイルを適用する
                if (leftMovingHandleCenterY < 30 || leftMovingHandleCenterX < 30) {
                    templateContainer.style.display = 'none';
                } else {
                    templateContainer.style.display = 'flex';
                }

                //template-containerのtopの位置は画面の一番上
                templateContainer.style.top = '0px';
                //template-containerの高さは画面の上からleftMovingHandleCenterYの位置まで
                templateContainer.style.height = leftMovingHandleCenterY - 25 + 'px';

                //template-containerの幅は画面左端からleftMovingHandleのleftの位置まで
                templateContainer.style.width = leftMovingHandleCenterX - leftMovingHandleWidth + 'px';
            }

            //toolbox-containerを取得
            const toolBoxContainer = this.shadowRoot.querySelector('tool-box');
            if (toolBoxContainer) {

                // leftMovingHandleCenterYが画面の下部から30pxの範囲であれば、toolbox-containerにdisplay:noneのスタイルを適用する
                if (leftMovingHandleCenterY > windowHeight - 30 || leftMovingHandleCenterX < 30) {
                    toolBoxContainer.style.display = 'none';
                } else {
                    toolBoxContainer.style.display = 'flex';
                }


                //toolbox-containerのtopの位置はleftMovingHandleのtopの位置 +　leftMovingHandleの高さの半分
                toolBoxContainer.style.top = leftMovingHandle.getBoundingClientRect().top + leftMovingHandle.getBoundingClientRect().height / 2 + 'px';

                //toolbox-containerの高さは表示領域の高さからleftMovingHandleCenterYを引き、leftMovingHandleHeightを引き、上、中央、下のそれぞれ10pxのマージン分を更に引いた値
                toolBoxContainer.style.height = windowHeight - leftMovingHandleCenterY - leftMovingHandleHeight + 'px';


                //toolbox-containerの幅は画面左端からleftMovingHandleのleftの位置まで
                toolBoxContainer.style.width = leftMovingHandleCenterX - leftMovingHandleWidth + 'px';

            }
        }
        this.updateCenterElementsPosition();
        return Promise.resolve();
    }

    handleLeftMovingHandleMouseDown(event) {

        // 'renderzone-pointer-events-disable' イベントを発行
        window.dispatchEvent(new CustomEvent('renderzone-pointer-events-disable', {
            bubbles: true,
            composed: true
        }));

        //leftMovingHandleを取得
        const leftMovingHandle = this.shadowRoot.querySelector('#leftMovingHandle');

        //eventがtouchEvent
        if (window.TouchEvent && event instanceof TouchEvent) {
            this.topDiff = event.touches[0].clientY - this.leftMovingHandleY;
            this.leftDiff = event.touches[0].clientX - this.leftMovingHandleX;
        } else {
            this.leftMovingHandleMoveing = true;
            this.topDiff = event.clientY - this.leftMovingHandleY;
            this.leftDiff = event.clientX - this.leftMovingHandleX;

            // グローバルイベントリスナーを追加
            window.addEventListener('mousemove', this._boundHandleLeftMouseMove);
            window.addEventListener('mouseup', this._boundHandleLeftMouseUp);
            window.addEventListener('keydown', this.handleKeyDown.bind(this));
        }
    }

    handleKeyDown(event) {
        //escキーを押したらマウスアップイベントを呼び出す
        if (event.keyCode === 27) {
            this.handleLeftMovingHandleMouseUp(event);
            this.handleRightMovingHandleMouseUp(event);
        }
    }

    handleLeftMovingHandleMouseUp(event) {
        this.leftMovingHandleMoveing = false;

        window.dispatchEvent(new CustomEvent('renderzone-pointer-events-enable', {
            bubbles: true,
            composed: true
        }));


        // グローバルイベントリスナーを削除
        window.removeEventListener('mousemove', this.handleLeftMovingHandleMouseMove);
        window.removeEventListener('mouseup', this.handleLeftMovingHandleMouseUp);
        //キーダウンイベントを削除
        window.removeEventListener('keydown', this.handleKeyDown);

        this.topDiff = null;
        this.leftDiff = null;
    }

    handleLeftMovingHandleMouseMove(event) {
        if (this.leftMovingHandleMoveing) {
            if (window.TouchEvent && event instanceof TouchEvent) {
                this.leftMovingHandleX = event.touches[0].clientX - this.leftDiff;
                this.leftMovingHandleY = event.touches[0].clientY - this.topDiff;
            } else {
                //this.leftMovingHandleXとthis.leftMovingHandleYの値をマウスカーソルの位置に更新する
                this.leftMovingHandleX = event.clientX - this.leftDiff;
                this.leftMovingHandleY = event.clientY - this.topDiff;
            }

            //leftMovingHandleの位置を更新する
            this.moveLeftHandle();
            event.preventDefault();
        }
    }


    /**
     * 右側ハンドルを動かしたときに呼び出す関数
     */
    async moveRightHandle() {
        //表示領域の縦横のサイズを取得する
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        const rightMovingHandle = this.shadowRoot.querySelector('#rightMovingHandle');
        if (rightMovingHandle) {

            //ハンドルを取得
            const rightMovingHandle = this.shadowRoot.querySelector('#rightMovingHandle');
            //handleのbottomが画面サイズより下になる場合は画面サイズ＋handleの高さで止める
            if (this.rightMovingHandleY > window.innerHeight - rightMovingHandle.getBoundingClientRect().height) {
                this.rightMovingHandleY = window.innerHeight - rightMovingHandle.getBoundingClientRect().height;
            }

            //handleのtopが0より小さくなる場合は0で止める
            if (this.rightMovingHandleY < 0) {
                this.rightMovingHandleY = 0;
            }

            //handle of rightが0より小さくなる場合は0で止める
            if (this.rightMovingHandleX < 0) {
                this.rightMovingHandleX = 0;
            }

            //handleのrightが画面サイズより大きくなる場合は画面サイズで止める
            if (this.rightMovingHandleX > window.innerWidth - rightMovingHandle.getBoundingClientRect().width) {
                this.rightMovingHandleX = window.innerWidth - rightMovingHandle.getBoundingClientRect().width;
            }

            rightMovingHandle.style.top = this.rightMovingHandleY + "px";
            rightMovingHandle.style.left = this.rightMovingHandleX + "px";

            //rightMovingHandleの縦方向の中央位置を取得
            const rightMovingHandleCenterY = rightMovingHandle.getBoundingClientRect().top + rightMovingHandle.getBoundingClientRect().height / 2;
            //rightMovingHandleの高さを取得
            const rightMovingHandleHeight = rightMovingHandle.getBoundingClientRect().height;

            //rightMovingHandleの横方向の中央位置を取得
            const rightMovingHandleCenterX = rightMovingHandle.getBoundingClientRect().left + rightMovingHandle.getBoundingClientRect().width / 2;
            //rightMovingHandleの幅を取得
            const rightMovingHandleWidth = rightMovingHandle.getBoundingClientRect().width;

            this.rightMovingHandleX = rightMovingHandle.getBoundingClientRect().left;
            this.rightMovingHandleY = rightMovingHandle.getBoundingClientRect().top;

            //property-containerを取得
            await this.importPropertyContainer();
            const propertyContainer = this.shadowRoot.querySelector('property-container');
            if (propertyContainer) {
                // rightMovingHandleCenterYが画面の上部から30pxの範囲であれば、property-containerにdisplay:noneのスタイルを適用する
                if (rightMovingHandleCenterY < 30 || rightMovingHandleCenterX > windowWidth - 60) {
                    propertyContainer.style.display = 'none';
                } else {
                    propertyContainer.style.display = 'flex';
                }

                //property-containerのtopの位置は画面の一番上
                propertyContainer.style.top = '0px';
                //property-containerの高さは画面の上からrightMovingHandleCenterYの位置まで
                propertyContainer.style.height = rightMovingHandleCenterY - 25 + 'px';

                //property-containerのleftをrightMovingHandleの位置にする
                propertyContainer.style.left = rightMovingHandle.getBoundingClientRect().left + rightMovingHandleWidth + 'px';
                //property-containerの幅はrightMovingHandleの位置から画面の右端まで
                propertyContainer.style.width = windowWidth - rightMovingHandleCenterX - rightMovingHandleWidth - 30 + 'px';

                //propertyContainerのShadowDOM内にあるattributes-containerを探す
                const attributesContainer = propertyContainer.shadowRoot.querySelector('attributes-container');
                attributesContainer.handleWindowResize();
            }

            //script-containerを取得
            await this.importScriptContainer();
            const scriptContainer = this.shadowRoot.querySelector('script-container');
            if (scriptContainer) {

                // rightMovingHandleCenterYが画面の下部から30pxの範囲であれば、script-containerにdisplay:noneのスタイルを適用する
                if (rightMovingHandleCenterY > windowHeight - 30 || rightMovingHandleCenterX > windowWidth - 60) {
                    scriptContainer.style.display = 'none';
                } else {
                    scriptContainer.style.display = 'flex';
                }

                //script-containerのtopの位置はrightMovingHandleのtopの位置 +　rightMovingHandleの高さの半分
                scriptContainer.style.top = rightMovingHandleCenterY + 5 + 'px';

                //script-containerの高さは表示領域の高さからrightMovingHandleCenterYを引き、rightMovingHandleHeightを引き、上、中央、下のそれぞれ10pxのマージン分を更に引いた値
                scriptContainer.style.height = windowHeight - rightMovingHandleCenterY - rightMovingHandleHeight + 'px';

                //script-containerのleftをrightMovingHandleの位置にする
                scriptContainer.style.left = rightMovingHandle.getBoundingClientRect().left + rightMovingHandleWidth + 'px';

                //script-containerの幅はrightMovingHandleの位置から画面の右端まで
                scriptContainer.style.width = windowWidth - rightMovingHandleCenterX - rightMovingHandleWidth - 30 + 'px';

                //scriptContainerのリサイズ
                scriptContainer.handleWindowResize();
            }
        }
        this.updateCenterElementsPosition();
        return Promise.resolve();
    }

    handleRightMovingHandleMouseDown(event) {

        // 'renderzone-pointer-events-enable' イベントを発行
        window.dispatchEvent(new CustomEvent('renderzone-pointer-events-disable', {
            bubbles: true,
            composed: true
        }));

        //rightMovingHandleを取得
        const rightMovingHandle = this.shadowRoot.querySelector('#rightMovingHandle');
        //rightMovingHandleのtopの位置を取得
        const rightMovingHandleTop = rightMovingHandle.getBoundingClientRect().top;
        //rightMovingHandleのleftの位置を取得
        const rightMovingHandleLeft = rightMovingHandle.getBoundingClientRect().left;

        //eventがtouchEvent
        if (window.TouchEvent && event instanceof TouchEvent) {
            this.topDiff = event.touches[0].clientY - this.rightMovingHandleY;
            this.rightDiff = event.touches[0].clientX - this.rightMovingHandleX;
        } else {
            this.rightMovingHandleMoveing = true;
            //topとマウスの位置の差分を取得
            this.topDiff = event.clientY - this.rightMovingHandleY;
            //leftとマウスの位置の差分を取得
            this.rightDiff = event.clientX - this.rightMovingHandleX;
            // グローバルイベントリスナーを追加
            window.addEventListener('mousemove', this.handleRightMovingHandleMouseMove.bind(this));
            window.addEventListener('mouseup', this.handleRightMovingHandleMouseUp.bind(this));
            //キーダウンイベントを追加
            window.addEventListener('keydown', this.handleKeyDown.bind(this));
        }
    }

    handleRightMovingHandleMouseUp(event) {
        this.rightMovingHandleMoveing = false;

        window.dispatchEvent(new CustomEvent('renderzone-pointer-events-enable', {
            bubbles: true,
            composed: true
        }));

        // グローバルイベントリスナーを削除
        window.removeEventListener('mousemove', this.handleRightMovingHandleMouseMove);
        window.removeEventListener('mouseup', this.handleRightMovingHandleMouseUp);
        window.removeEventListener('keydown', this.handleKeyDown);

        this.topDiff = null;
        this.rightDiff = null;
    }

    handleRightMovingHandleMouseMove(event) {

        if (this.rightMovingHandleMoveing) {
            if (window.TouchEvent && event instanceof TouchEvent) {
                this.rightMovingHandleX = event.touches[0].clientX - this.rightDiff;
                this.rightMovingHandleY = event.touches[0].clientY - this.topDiff;
            } else {
                //this.rightMovingHandleXとthis.rightMovingHandleYの値をマウスカーソルの位置に更新する
                this.rightMovingHandleX = event.clientX - this.rightDiff;
                this.rightMovingHandleY = event.clientY - this.topDiff;
            }

            //rightMovingHandleの位置を更新する
            this.moveRightHandle();
            event.preventDefault();

            //property-containerを取得
            const propertyContainer = this.shadowRoot.querySelector('property-container');
            if (propertyContainer) {
                //propertyContainerからattribute-containerを取得
                const attributeContainer = propertyContainer.shadowRoot.querySelector('attributes-container');
                if (attributeContainer) {
                    attributeContainer.handleWindowResize();
                }
            }

            //script-containerを取得
            const scriptContainer = this.shadowRoot.querySelector('script-container');
            if (scriptContainer) {
                //scriptContainerからevent-containerを取得
                const eventContainer = scriptContainer.shadowRoot.querySelector('event-container');
                if (eventContainer) {
                    eventContainer.handleWindowResize();
                }
            }

        }
    }

    displayDebugInfo(message) {
        var debugOutput = this.shadowRoot.getElementById("debugOutput");
        debugOutput.innerText = message; // デバッグ情報を表示
    }

    getTouchCoords(touchEvent) {
        // 単一のタッチイベントから座標を取得
        return {
            x: touchEvent.touches[0].clientX,
            y: touchEvent.touches[0].clientY
        };
    }

    //leftTouch
    handleLeftTouchStart(e) {
        const coords = this.getTouchCoords(e);
        this.touchStartX = coords.x;
        this.touchStartY = coords.y;
        this.leftMovingHandleMoveing = false; // まだドラッグ開始とは認めない

        const currentTime = new Date().getTime();
        const tapLength = currentTime - this.lastLeftTapTime;

        if (tapLength < this.doubleTapThreshold && tapLength > 0) {
            // ダブルタップが成立した場合は、シングルタップ用の長押しタイマーを解除
            clearTimeout(this.touchTimer);
            this.touchTimer = null;
            this.toggleLeftPanel();
            this.lastLeftTapTime = 0;
            e.preventDefault();
            return;
        }
        this.lastLeftTapTime = currentTime;

        this.touchTimer = setTimeout(function () {
            // MOVE_THRESHOLDの範囲内であればドラッグを開始
            if (!this.leftMovingHandleMoveing) {
                this.leftMovingHandleMoveing = true;
                this.handleLeftMovingHandleMouseDown(e);
                if ('vibrate' in navigator) {
                    navigator.vibrate(50);
                }
            }
        }.bind(this), 300);

        e.preventDefault();
    }

    handleLeftTouchEnd(e) {
        clearTimeout(this.touchTimer); // 長押しタイマーをクリア
        this.handleLeftMovingHandleMouseUp(e);
    }

    handleLeftTouchMove(e) {
        // タッチが動いた場合は長押しカウントダウンをキャンセル
        const coords = this.getTouchCoords(e);
        const dx = Math.abs(this.touchStartX - coords.x);
        const dy = Math.abs(this.touchStartY - coords.y);


        // 移動距離が閾値を超えた場合にのみドラッグ処理
        if (dx > this.MOVE_THRESHOLD || dy > this.MOVE_THRESHOLD) {
            if (this.leftMovingHandleMoveing) {
                this.leftMovingHandleMoveing = true;
                this.handleLeftMovingHandleMouseMove(e); // 実際のドラッグ処理関数
            } else {
                this.leftMovingHandleMoveing = false;
                clearTimeout(this.touchTimer); // 長押しタイマーをクリア
            }
        }
    }

    /**
     * 左側パネルをトグルで開閉します
     */
    toggleLeftPanel() {
        const windowWidth = window.innerWidth;
        // PC（画面幅1024px以上）の場合は、ダブルクリック等での自動開閉を制限する
        if (windowWidth >= 1024) return;

        // 現在の位置が画面中央より右側（開いている）なら閉じる、左側（閉じている）なら開く
        if (this.leftMovingHandleX > windowWidth * 0.5) {
            this.leftMovingHandleX = 0; // 左側を完全に閉じる
        } else {
            this.leftMovingHandleX = windowWidth; // 左側を開く
            // 左側を全開にする場合、右側の操作を確保するため右側は完全に画面外へ閉じる
            const rightHandle = this.shadowRoot.querySelector('#rightMovingHandle');
            const handleWidth = rightHandle ? rightHandle.getBoundingClientRect().width : 25;
            this.rightMovingHandleX = windowWidth - handleWidth;
        }
        this.moveLeftHandle();
        this.moveRightHandle();
    }

    /**
     * 右側パネルをトグルで開閉します
     */
    toggleRightPanel() {
        const windowWidth = window.innerWidth;
        // PC（画面幅1024px以上）の場合は、ダブルクリック等での自動開閉を制限する
        if (windowWidth >= 1024) return;

        const rightHandle = this.shadowRoot.querySelector('#rightMovingHandle');
        const handleWidth = rightHandle ? rightHandle.getBoundingClientRect().width : 25;
        const rightMaxX = windowWidth - handleWidth;

        // 現在の位置が画面中央より左側（開いている）なら閉じる、右側（閉じている）なら開く
        if (this.rightMovingHandleX < windowWidth * 0.5) {
            this.rightMovingHandleX = rightMaxX; // 右側を完全に閉じる
        } else {
            this.rightMovingHandleX = 0; // 右側を開く
            this.leftMovingHandleX = 0; // 左側を完全に閉じる
        }
        this.moveLeftHandle();
        this.moveRightHandle();
    }

    //rightHandleTouch
    handleRightTouchStart(e) {
        const coords = this.getTouchCoords(e);
        this.touchStartX = coords.x;
        this.touchStartY = coords.y;
        this.rightMovingHandleMoveing = false; // まだドラッグ開始とは認めない

        const currentTime = new Date().getTime();
        const tapLength = currentTime - this.lastRightTapTime;

        if (tapLength < this.doubleTapThreshold && tapLength > 0) {
            // ダブルタップが成立した場合は、シングルタップ用の長押しタイマーを解除
            clearTimeout(this.touchTimer);
            this.touchTimer = null;
            this.toggleRightPanel();
            this.lastRightTapTime = 0;
            e.preventDefault();
            return;
        }
        this.lastRightTapTime = currentTime;

        this.touchTimer = setTimeout(function () {
            // MOVE_THRESHOLDの範囲内であればドラッグを開始
            if (!this.rightMovingHandleMoveing) {
                this.rightMovingHandleMoveing = true;
                this.handleRightMovingHandleMouseDown(e);
                if ('vibrate' in navigator) {
                    navigator.vibrate(50);
                }
            }
        }.bind(this), 300);

        e.preventDefault();
    }

    handleRightTouchEnd(e) {
        clearTimeout(this.touchTimer); // 長押しタイマーをクリア
        this.handleRightMovingHandleMouseUp(e);
    }

    handleRightTouchMove(e) {
        // タッチが動いた場合は長押しカウントダウンをキャンセル
        const coords = this.getTouchCoords(e);
        const dx = Math.abs(this.touchStartX - coords.x);
        const dy = Math.abs(this.touchStartY - coords.y);


        // 移動距離が閾値を超えた場合にのみドラッグ処理
        if (dx > this.MOVE_THRESHOLD || dy > this.MOVE_THRESHOLD) {
            if (this.rightMovingHandleMoveing) {
                this.rightMovingHandleMoveing = true;
                this.handleRightMovingHandleMouseMove(e); // 実際のドラッグ処理関数
            } else {
                this.rightMovingHandleMoveing = false;
                clearTimeout(this.touchTimer); // 長押しタイマーをクリア
            }
        }
    }

    updateCenterElementsPosition() {
        // requestAnimationFrame を使って、ブラウザの次の描画前に処理を実行
        requestAnimationFrame(() => {
            const leftHandle = this.shadowRoot.querySelector('#leftMovingHandle');
            const rightHandle = this.shadowRoot.querySelector('#rightMovingHandle');
            const platformSwitcher = this.shadowRoot.querySelector('platform-switcher');
            const platformBottomMenu = this.shadowRoot.querySelector('platform-bottom-menu');

            // すべての要素が存在することを確認
            if (leftHandle && rightHandle && platformSwitcher && platformBottomMenu) {
                const leftRect = leftHandle.getBoundingClientRect();
                const rightRect = rightHandle.getBoundingClientRect();

                // 2つのハンドルの間の中心X座標を計算
                const centerX = leftRect.right + (rightRect.left - leftRect.right) / 2;

                // 計算した中心位置を各要素の left に設定
                // transform: translateX(-50%) はCSSで維持されるので、これで中央揃えになる
                platformSwitcher.style.left = `${centerX}px`;
                platformBottomMenu.style.left = `${centerX}px`;
            }
        });
    }

    /**
     * HTMLタグを追加する際、プリセットの選択肢と手入力を備えたダイアログを表示し、
     * 決定されたタグ名を非同期で返します。
     */
    async showHtmlTagSelectDialog() {
        const dialog = this.shadowRoot.querySelector('#html-tag-select-dialog');
        const input = this.shadowRoot.querySelector('#custom-tag-input');
        if (input) input.value = '';

        const confirmed = await dialog.show();
        if (confirmed) {
            const tagName = input.value.trim().toLowerCase();
            return tagName || null;
        }
        return null;
    }

    _selectPresetTag(tag) {
        const dialog = this.shadowRoot.querySelector('#html-tag-select-dialog');
        const input = this.shadowRoot.querySelector('#custom-tag-input');
        if (input) input.value = tag;
        const okBtn = dialog.querySelector('[slot="ok-slot"]');
        if (okBtn) okBtn.click();
    }

    _handleCustomTagKeydown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            const dialog = this.shadowRoot.querySelector('#html-tag-select-dialog');
            const okBtn = dialog.querySelector('[slot="ok-slot"]');
            if (okBtn) okBtn.click();
        }
    }


    render() {
        // appHeaderをローカル変数として取得
        const appHeader = this.appSettingStore?.getState().appSetting.app_header || '';

        return html`
            <!-- デバッグ情報を表示するための要素 -->
            <!--<div id="debugOutput" style="position: fixed; top: 0; left: 0; z-index: 1000; color: white; background: black; padding: 5px;"></div>-->

            <app-container-loading-overlay></app-container-loading-overlay>

            <alert-component></alert-component>

            <snapshot-manager></snapshot-manager>

            <div id="app-editor" class="component">
                <platform-background></platform-background>
                <platform-switcher ></platform-switcher>
                
                <platform-container ></platform-container>

                <platform-bottom-menu></platform-bottom-menu>

                <file-explorer></file-explorer>

                <!-- ツールボックスアイテム編集画面 -->
                <tool-box-item-editor></tool-box-item-editor>

                <left-container>
                    <moving-handle id="leftMovingHandle" @mousedown="${this.handleLeftMovingHandleMouseDown}">
                        <div style="position: absolute;font-size: 18px;font-weight: bold;color: #a3a3a3;position: absolute;/* top: -1px; */bottom: -2px;left: 2px;font-size: 12px;font-weight: bold;color: #a3a3a3;">L</div>
                    </moving-handle>
                    <template-container></template-container>
                    <tool-box></tool-box>
                </left-container>

                <right-container>
                    <moving-handle id="rightMovingHandle" @mousedown="${this.handleRightMovingHandleMouseDown}">
                        <div style="position: absolute;/* top: -1px; *//* right: 3px; */bottom: -2px;right: 2px;font-size: 12px;font-weight: bold;color: #a3a3a3;">R</div>
                    </moving-handle>
                    <property-container></property-container>
                    <script-container></script-container>
                </right-container>


                <!-- AI Coder -->
                <ai-coder-window></ai-coder-window>

                <!-- AI Agent -->
                <agent-chat-window .appHeader=${appHeader}></agent-chat-window>

                <app-tour-guide id="tour-guide"></app-tour-guide>
                <app-tutorial-modal id="tutorial-modal"></app-tutorial-modal>
                <starter-template-modal></starter-template-modal>
            </div>
            
            <!-- HTMLタグ選択ダイアログ -->
            <message-box id="html-tag-select-dialog" boxWidth="420px">
              <div slot="message-slot">
                <p style="text-align: center; font-weight: bold; margin-bottom: 15px; font-size: 15px; color: #333;">追加するHTMLタグを選択または入力</p>
                <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-bottom: 20px;">
                  ${['div', 'span', 'p', 'img', 'a', 'ul', 'li', 'br', 'h1', 'h2', 'h3', 'strong'].map(tag => html`
                    <button type="button" class="preset-tag-button" style="width: 100%; height: 35px; border-radius: 4px; font-size: 13px; font-weight: bold; display: flex; align-items: center; justify-content: center; border: 1px solid #ccc; background: white; cursor: pointer;" @click="${() => this._selectPresetTag(tag)}">${tag}</button>
                  `)}
                </div>
                <div style="display: flex; flex-direction: column; gap: 8px; text-align: left;">
                  <label for="custom-tag-input" style="font-size: 12px; font-weight: bold; color: #555;">その他のタグを手入力:</label>
                  <input type="text" id="custom-tag-input" placeholder="例: section, article" @keydown="${this._handleCustomTagKeydown}" style="width: 100%; box-sizing: border-box; padding: 10px; border: 1px solid #ccc; border-radius: 5px; font-size: 14px;">
                </div>
              </div>
              <button slot="ok-slot" class="confirm-ok-button">追加</button>
              <button slot="cancel-slot" class="confirm-cancel-button">キャンセル</button>
            </message-box>

            <!-- 画面端D&D用エッジトリガー -->
            <div class="edge-trigger left ${this.isGlobalDragging && this.leftMovingHandleX <= 0 ? 'active' : ''} ${this.dragHoverEdge === 'left' ? 'hover' : ''}">
                <i class="fa-solid fa-angles-right"></i>
            </div>
            <div class="edge-trigger right ${this.isGlobalDragging && this.rightMovingHandleX >= window.innerWidth - 40 ? 'active' : ''} ${this.dragHoverEdge === 'right' ? 'hover' : ''}">
                <i class="fa-solid fa-angles-left"></i>
            </div>
    `;
    }
}
